import React from "react";
import {Row, Carousel, Icon} from 'antd';
import background1 from "../img/bground1.png"
import background2 from "../img/bground2.png"

export default class ImageBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0
        }
    }
    componentDidMount() {
        const width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 17;
        const height = width / 4;
        this.setState({ width, height });
        window.onresize = () => {
            const width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 17;
            const height = width / 4;
            this.setState({ width, height });
        };
    }
    prev = () => {
        this.refs.carousel.prev();
    };
    next = () => {
        this.refs.carousel.next();
    };
    render() {
        const { width, height } = this.state;
        return (
            <Row style={{ position: 'relative', marginTop: 72,zIndex:99 }}>
                <Row
                    type="flex"
                    justify="center"
                    align="middle"
                    style={{
                        position: 'absolute',
                        height: height,
                        left: 10,
                        top: 0,
                        zIndex: 99,
                        color: 'rgba(255, 255, 255, 0.6)',
                        cursor: 'pointer'
                    }}>
                    <Icon type="left"  style={{fontSize: 45}} onClick={this.prev}/>
                </Row>
                <Carousel effect="fade" autoplay={true} ref="carousel">
                    <img src={background1} alt="banner" width={width} height={height}/>
                    <img src={background2} alt="banner" width={width} height={height}/>
                </Carousel>
                <Row
                    type="flex"
                    justify="center"
                    align="middle"
                    style={{
                        position: 'absolute',
                        height: height,
                        right: 10,
                        top: 0,
                        zIndex: 99,
                        color: 'rgba(255, 255, 255, 0.6)',
                        cursor: 'pointer'
                    }}>
                    <Icon type="right"  style={{fontSize: 45}} onClick={this.next}/>
                </Row>
            </Row>
        )
    }
}
